import { makeStyles } from '@material-ui/core/styles';
import { AI_ASSISTANT_TYPOGRAPHY_STYLES } from 'features/ai-assistant/constants';

export const useMessageStyles = makeStyles(theme => ({
  messageRow: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(2)
  },
  messageRowOutbound: {
    alignItems: 'flex-end'
  },
  messageRowInbound: {
    alignItems: 'flex-start'
  },
  messageBubble: {
    backgroundColor: theme.palette.primary.fill,
    borderRadius: theme.spacing(2, 2, 0, 2),
    hyphens: 'auto',
    maxWidth: ({ messageFullWidth } = {}) => (messageFullWidth ? '100%' : '50%'),
    overflowWrap: 'break-word',
    padding: theme.spacing(2),
    whiteSpace: 'normal',
    wordWrap: 'break-word',

    [theme.breakpoints.down('sm')]: {
      maxWidth: '60%'
    }
  },
  responseContainer: {
    hyphens: 'auto',
    maxWidth: ({ messageFullWidth } = {}) => (messageFullWidth ? '100%' : '80%'),
    overflowWrap: 'break-word',
    whiteSpace: 'normal',
    wordWrap: 'break-word',

    [theme.breakpoints.down('sm')]: {
      maxWidth: '70%'
    }
  },
  responseContainerLatest: {
    minHeight: 'calc(100dvh - 250px)'
  },
  messageText: {
    color: theme.palette.common.white,
    whiteSpace: 'pre-wrap'
  },
  assistantTypography: {
    ...AI_ASSISTANT_TYPOGRAPHY_STYLES
  },
  skeletonContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
    minWidth: 300,
    width: '100%'
  },
  animatedLoaderContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: theme.spacing(2, 0),
    gap: theme.spacing(1)
  },
  dot: {
    width: 10,
    height: 10,
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    animation: '$pulse 1.4s ease-in-out infinite',
    boxShadow: `0 2px 8px ${theme.palette.primary.main}40`,
    '&:nth-child(1)': {
      animationDelay: '0s'
    },
    '&:nth-child(2)': {
      animationDelay: '0.2s'
    },
    '&:nth-child(3)': {
      animationDelay: '0.4s'
    }
  },
  '@keyframes pulse': {
    '0%, 80%, 100%': {
      opacity: 0.3,
      transform: 'scale(1)'
    },
    '40%': {
      opacity: 1,
      transform: 'scale(1.3)'
    }
  }
}));
